import { Component, OnInit } from '@angular/core';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {ApprovalService} from '../../../service/approval.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ReturnRemarkComponent} from '../../../approval-process/return-remark/return-remark.component';
import {ReturnRequestComponent} from '../../../blacklist-process/blacklist-process-verification/blacklist-verification-request-viewer/return-request/return-request.component';
import {RemarkComponent} from '../../../approval-process/remark/remark.component';
import {BlacklistApproveChecklistComponent} from '../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {FwdRemarkComponent} from '../../../approval-process/fwd-remark/fwd-remark.component';

@Component({
  selector: 'app-suspend-blacklist-verification',
  templateUrl: './suspend-blacklist-verification.component.html',
  styleUrls: ['./suspend-blacklist-verification.component.scss']
})
export class SuspendBlacklistVerificationComponent implements OnInit {

  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();
  stage: string = WorkflowEnum.SUSPEND_BLACKLIST;

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'APPROVE';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.BLACKLIST;


    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  returnBlacklist() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRequestComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  blacklistData() {

  }
}
